import { BlueBirdTheme, Chip as BaseChip, Dropdown as BaseDropdown } from "@kitbird/core";
import styled, { css } from "styled-components";
import SvgDiv from "../../../../../components/SvgDiv";
import rightCornerBg from "../../../../../assets/images/right_corner_medium_bg_inverted.svg";

export const ModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ScrollableFormArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
`;

export const FormGrid = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ReplacementSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: stretch;
  /* border: 1px solid ${BlueBirdTheme.colors.primary[200]}; */
  /* padding: 1rem; */
  border-radius: 16px;
  /* overflow: hidden; */
`;

export const SwitchIconContainer = styled(SvgDiv)`
  width: 20px;
  height: 20px;
  padding: 0.5rem;
  border: 1px solid ${BlueBirdTheme.colors.gray.line};
  border-radius: 12px;
  margin: 0 auto;
`;

export const ReplacementFooter = styled.div`
  border-top: 1px dashed ${BlueBirdTheme.colors.primary[200]};
  margin: 0 -1rem -1rem -1rem;
`;

export const ReplacementCard = styled.div`
  background-color: ${BlueBirdTheme.colors.blueGray.background};
  padding: 1rem;
  min-height: 120px;
  display: flex;
  gap: 1.5rem;
`;

export const UserPositions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
`;

export const PositionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const StatusAndPoolRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledBadge = styled.div<{ $color: string; $backgroundColor: string }>`
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$color};
  padding: 4px 12px;
  border-radius: 4px;
  width: fit-content;
  text-align: center;
  white-space: nowrap;
  height: fit-content;
`;

export const InfoCard = styled.div<{
  $isReplacement?: boolean;
  $invertColor?: boolean;
  $minHeight?: string;
}>`
  display: flex;
  gap: 1.5rem;
  padding: 1rem;
  border-radius: 14px;
  position: relative;
  flex: 1;
  
  ${({ $isReplacement, $invertColor, $minHeight }) => ($isReplacement
    ? css`
        background-color: ${BlueBirdTheme.colors.blueGray.background};
        min-height: ${$minHeight ?? "120px"};
        border: none;
        border-radius: 0;
      `
    : css`
        background-color: ${$invertColor ? BlueBirdTheme.colors.gray.background : BlueBirdTheme.colors.primary[100]};
        border: 1px solid ${BlueBirdTheme.colors.primary[200]};
        min-height: ${$minHeight ?? "175px"};
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: url(${rightCornerBg});
          background-attachment: local;
          background-position: top right;
          background-repeat: no-repeat;
          border-radius: inherit;
          filter: ${$invertColor ? "grayscale(1)" : "none"};
        }
      `)}
`;

export const UserInfo = styled.div<{ $isVerticallyCentered?: boolean, $isSimple?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: ${(props) => (props.$isSimple ? "1" : "0 0 40%")};
  justify-content: ${(props) => (props.$isVerticallyCentered ? "center" : "flex-start")};
`;
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 155px;
  width: 100%;
`;

export const HistoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: .5rem;
`;

export const HistoryItem = styled.div`
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: flex-start;
`;

export const HistoryGroup = styled.div<{ withBackground?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${(props) => props.withBackground && css`
    background-color: ${BlueBirdTheme.colors.gray.background};
    padding: .4rem;
    border-radius: 12px;
  `}
`;

export const HistoryDetailRow = styled.div`
  padding: .2rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
`;

export const HistoryDetailLabel = styled.div`
  flex: 0.25;
`;

export const HistoryDetailValue = styled.div`
  flex: 1;
  span {
    margin-right: .5rem;
  }
`;

export const MutationPageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledChipWrapper = styled(BaseChip)`
  & {
    display: inline-flex;
    align-items: center;
    overflow: visible !important;
    height: auto !important;
  }

  svg[data-testid="cross-icon-element"] {
    order: -1;
    margin-right: 8px;
  }

  span#chipLabelId {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  span#chipLabelId::after {
    content: var(--subtext-content);
    font-size: 12px;
    color: #444444;
    line-height: 12px;
    font-weight: 500;
    margin-top: 2px;
    white-space: nowrap;
  }
`;
